import React , {useState, useEffect} from "react";
import { Container } from "shards-react";
import classNames from "classnames";
import useToken from "shared/hook/useToken";
import { userSidebarContext } from "shared/hook/useOpenMenuContext";
import useCurrentUser from "shared/hook/useCurrentUser";

const { openMenu } = useToken();

const Layout = (props) => {
    const { children } = props;
    const { token } = useToken();
    const  {openSidebar } = userSidebarContext();
    const { curruntUser } = useCurrentUser();
    const [userType, setUserType] = useState(0);


  useEffect(() => {
    if (curruntUser) {
        setUserType(curruntUser.detail.userType);
    }
  }, [curruntUser]);

    const classes = classNames(
        'main-content-container',
        (openSidebar && token && userType != 0 && userType != 2 && userType != 5) && "open"
    );

    return (
        <Container fluid className={classes}>
            {children}
        </Container>
    )
}

export default Layout;
